// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import { CollectionStatus, CollectionType } from '@shared/constants/collection';

export interface CollectionDTO {
  id: number;
  collectionName: string;
  collectionType: CollectionType;
  status: CollectionStatus;
  availableStatuses: Array<CollectionStatus>;
  notes: string;
  scheduledDate: string;
  startDate: string;
  platformId: number;
  forwardLap: number;
  sideLap: number;
  gimbalAngle: number;
  aglAltitude: number;
  camInterval: number;
  radius: number;
  aboveCrown: boolean;
  useAutoNav: boolean;
  orbits: number;
  isBlocked?: boolean;
  platformSerialNumber?: string;
}

export default class Collection {
  id: number;
  collectionName: string;
  collectionType: CollectionType;
  status: CollectionStatus;
  availableStatuses: Array<CollectionStatus>;
  notes: string;
  scheduledDate: string;
  startDate: string;
  platformId: number;
  forwardLap: number;
  sideLap: number;
  gimbalAngle: number;
  aglAltitude: number;
  camInterval: number;
  radius: number;
  aboveCrown: boolean;
  useAutoNav: boolean;
  orbits: number;
  platformSerialNumber: string;
  isBlocked: boolean;

  constructor(dto: CollectionDTO) {
    this.update(dto);
  }

  get asJson(): CollectionDTO {
    return {
      id: this.id,
      collectionName: this.collectionName,
      collectionType: this.collectionType,
      status: this.status,
      notes: this.notes,
      scheduledDate: this.scheduledDate,
      startDate: this.startDate,
      platformId: this.platformId,
      forwardLap: this.forwardLap,
      sideLap: this.sideLap,
      gimbalAngle: this.gimbalAngle,
      aglAltitude: this.aglAltitude,
      camInterval: this.camInterval,
      radius: this.radius,
      aboveCrown: this.aboveCrown,
      orbits: this.orbits,
      isBlocked: this.isBlocked,
      useAutoNav: this.useAutoNav,
      availableStatuses: this.availableStatuses,
      platformSerialNumber: this.platformSerialNumber
    };
  }

  update(newData: Partial<CollectionDTO>): CollectionDTO {
    const allData = { ...this.asJson, ...newData };

    Object.assign(this, allData);

    return this.asJson;
  }
}
